/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssistantPermissionsParser = 
/* #__PURE__ */ parsers.object([
    ['view', codecBoolean],
    ['viewSystemPrompt', codecBoolean, 'view_system_prompt'],
    ['manage', codecBoolean],
]);
export class AssistantPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssistantPermissionsParser.decode(input).map(res => new AssistantPermissions(res));
    }
    static unsafeDecode(input) {
        return AssistantPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssistantPermissionsParser.encode(data);
    }
    static schema() {
        return AssistantPermissionsParser.schema();
    }
}
